export module ProvidersEnum {
    export enum ErrorCode {
        Unauthorized = 401,
        NotFound = 404,
        ValidationError = 400,
        InternalServerError = 500,
        IsNotProviderAnyMore = 601
    }
}
export module ProvidersEnum {
    export enum WeekDay {
        None = 0,
        Monday = 1,
        Tuesday = 2,
        Wednesday = 4,
        Thursday = 8,
        Friday = 16,
        Saturday = 32,
        Sunday = 64
    }
}
export module ProvidersEnum {
    export enum SortOrder {
        None = 0,
        Asc = 1,
        Desc = 2
    }
}
